import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyModal({
  isOpen,
  onClose
}: PrivacyModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-130">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-131">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-ink/60 backdrop-blur-sm" onClick={onClose} data-id="element-132" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative bg-base rounded-3xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden border border-sage" data-id="element-133">
            {/* Header */}
            <div className="sticky top-0 bg-base border-b border-sage px-6 py-4 flex items-center justify-between z-10" data-id="element-134">
              <h2 className="font-heading text-2xl text-primary" data-id="element-135">
                Política de Privacidad
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-sage transition-colors text-ink/60 hover:text-ink" aria-label="Cerrar" data-id="element-136">
                <XIcon className="w-5 h-5" data-id="element-137" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto max-h-[calc(85vh-72px)] text-ink/80 leading-relaxed space-y-6 text-sm" data-id="element-138">
              <p className="text-ink/50 text-xs" data-id="element-139">
                Última actualización:{' '}
                {new Date().toLocaleDateString('es-ES', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
              </p>

              <section data-id="element-140">
                <h3 className="font-bold text-ink text-base mb-2" data-id="element-141">
                  1. Información General
                </h3>
                <p data-id="element-142">
                  En Cero Inflamación 7D nos comprometemos a proteger tu
                  privacidad. Esta política describe cómo recopilamos, usamos y
                  protegemos tu información personal cuando visitas nuestro
                  sitio web o adquieres nuestros productos digitales.
                </p>
              </section>

              <section data-id="element-143">
                <h3 className="font-bold text-ink text-base mb-2" data-id="element-144">
                  2. Información que Recopilamos
                </h3>
                <p data-id="element-145">
                  Podemos recopilar la siguiente información cuando realizas una
                  compra o interactúas con nuestro sitio:
                </p>
                <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-146">
                  <li data-id="element-147">Nombre y dirección de correo electrónico</li>
                  <li data-id="element-148">
                    Información de pago (procesada de forma segura por terceros)
                  </li>
                  <li data-id="element-149">Datos de navegación y uso del sitio web</li>
                </ul>
              </section>

              <section data-id="element-150">
                <h3 className="font-bold text-ink text-base mb-2" data-id="element-151">
                  3. Uso de la Información
                </h3>
                <p data-id="element-152">Utilizamos tu información personal para:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-153">
                  <li data-id="element-154">Procesar y entregar tu compra del protocolo digital</li>
                  <li data-id="element-155">Enviarte actualizaciones relacionadas con tu compra</li>
                  <li data-id="element-156">Mejorar nuestros productos y servicios</li>
                  <li data-id="element-157">Cumplir con obligaciones legales aplicables</li>
                </ul>
              </section>

              <section data-id="element-158">
                <h3 className="font-bold text-ink text-base mb-2" data-id="element-159">
                  4. Protección de Datos
                </h3>
                <p data-id="element-160">
                  Implementamos medidas de seguridad técnicas y organizativas
                  para proteger tu información personal contra acceso no
                  autorizado, pérdida o alteración. Nunca vendemos ni
                  compartimos tu información personal con terceros para fines de
                  marketing.
                </p>
              </section>

              <section data-id="element-161">
                <h3 className="font-bold text-ink text-base mb-2" data-id="element-162">
                  5. Cookies
                </h3>
                <p data-id="element-163">
                  Nuestro sitio web puede utilizar cookies para mejorar tu
                  experiencia de navegación y analizar el tráfico del sitio.
                  Puedes configurar tu navegador para rechazar cookies, aunque
                  esto podría afectar la funcionalidad del sitio.
                </p>
              </section>

              <section data-id="element-164">
                <h3 className="font-bold text-ink text-base mb-2" data-id="element-165">
                  6. Tus Derechos
                </h3>
                <p data-id="element-166">Tienes derecho a:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-167">
                  <li data-id="element-168">
                    Acceder a la información personal que tenemos sobre ti
                  </li>
                  <li data-id="element-169">Solicitar la corrección o eliminación de tus datos</li>
                  <li data-id="element-170">Retirar tu consentimiento en cualquier momento</li>
                  <li data-id="element-171">
                    Presentar una queja ante la autoridad de protección de datos
                    correspondiente
                  </li>
                </ul>
              </section>

              <section data-id="element-172">
                <h3 className="font-bold text-ink text-base mb-2" data-id="element-173">
                  7. Productos Digitales
                </h3>
                <p data-id="element-174">
                  Al adquirir Cero Inflamación 7D, recibirás acceso inmediato al
                  contenido digital. Dado que se trata de un producto digital
                  descargable, las devoluciones están sujetas a nuestra política
                  de reembolso específica.
                </p>
              </section>

              <section data-id="element-175">
                <h3 className="font-bold text-ink text-base mb-2" data-id="element-176">
                  8. Descargo de Responsabilidad Médica
                </h3>
                <p data-id="element-177">
                  La información proporcionada en nuestro protocolo es solo para
                  fines educativos e informativos. No sustituye el consejo,
                  diagnóstico o tratamiento médico profesional. Siempre consulta
                  con un profesional de la salud calificado antes de realizar
                  cambios en tu dieta o estilo de vida.
                </p>
              </section>

              <section data-id="element-178">
                <h3 className="font-bold text-ink text-base mb-2" data-id="element-179">
                  9. Cambios a esta Política
                </h3>
                <p data-id="element-180">
                  Nos reservamos el derecho de actualizar esta política de
                  privacidad en cualquier momento. Los cambios serán publicados
                  en esta página con la fecha de la última actualización.
                </p>
              </section>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}